import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { NotificationsProvider } from '@toolpad/core/useNotifications';
import {SalepointProvider} from "./SalepointsContext.tsx";
import LogRocket from 'logrocket';
import {BasketProvider} from "./BasketContext.tsx";
LogRocket.init('fv8h3t/ssap');
const appProps = JSON.parse(document.getElementById("page").innerText)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <NotificationsProvider>
          <SalepointProvider>
              <BasketProvider>
              <App component={appProps.component} />
              </BasketProvider>
          </SalepointProvider>
      </NotificationsProvider>
  </StrictMode>,
)
